export default {
  choose_preferred_wallet: "Wähle bevorzugte Wallet",
  connect_mobile_wallet: "Verbinde mit Mobile Wallet",
  scan_qrcode_with_wallet: "Scanne den QR-code mit einer WalletConnect kompatiblen Wallet",
  return_to_mobile_options: "Zurück zur Wallet-Anbieter Übersicht",
  view_qrcode_option: "QR-code Anzeigen",
  connect: "Verbinden",
};
